import { queryClient, apiRequest } from "../lib/queryClient";

const cmsKey = "contents";

export function useContents(options = {}) {
  const {
    filters = {},
    sort = { field: "created_at", direction: "desc" },
    pagination = { page: 1, limit: 10 },
  } = options;

  const fetchContents = async (pageId) => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pagination.page);
    queryParams.append("limit", pagination.limit);
    queryParams.append("sortField", sort.field);
    queryParams.append("sortDirection", sort.direction);

    for (const [key, value] of Object.entries(filters)) {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, value);
      }
    }
    const response = await apiRequest(
      `/admin/cms/${pageId}?${queryParams.toString()}`,
      {
        method: "GET",
      }
    );
    return response;
  };

  const createContent = async (pageData) => {
    const response = await apiRequest("/admin/contents", {
      method: "POST",
      body: JSON.stringify(pageData),
    });
    queryClient.invalidateQueries({ queryKey: [cmsKey] });
    return response;
  };

  const updateContent = async (id, pageData) => {
    const response = await apiRequest(`/admin/contents/${id}`, {
      method: "PUT",
      body: JSON.stringify(pageData),
    });
    queryClient.invalidateQueries({ queryKey: [cmsKey] });
    return response;
  };

  const deleteContent = async (pageId) => {
    await apiRequest(`/admin/contents/${pageId}`, {
      method: "DELETE",
    });
    queryClient.invalidateQueries({ queryKey: [cmsKey] });
    return pageId;
  };

  return {
    fetchContents,
    createContent,
    updateContent,
    deleteContent,
  };
}
